module.exports = __webpack_public_path__ + "static/media/T6-Git.be9c3d29.svg";